var t;
import r from "react";
let a = (t = r.startTransition) != null ? t : function (i) {
  i();
};
export { a as startTransition };